import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Form, Input, Radio } from 'antd';
import { EditorElementPopover } from '../EditorElementPopover';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const FormItem = Form.Item;

export class PVideo extends React.Component {
  state = {
    showBtn: false,
  };

  static propTypes = {
    youtubeid: PropTypes.string, // Youtube video id (eg : mgjD688uNVo)
    aspect: PropTypes.string, // 4by3, 16by9

    className: PropTypes.string,
    // style: PropTypes.object,

    updateNode: PropTypes.func,
    address: PropTypes.array,
    publish: PropTypes.bool,
  };

  static defaultProps = {
    youtubeid: 's5ZNF_nTDbo',
    aspect: '16by9',
    publish: false,
  };

  onChange = (e) => {
    const size = e.target.value;
    this.props.updateNode(this.props.address, { size });
  }

  onURLEnter = (e) => {
    const urlStr = e.target.value;

    let youtubeid = '';
    if (urlStr.match(/embed\/(\w+)/i)) {
      [, youtubeid] = urlStr.match(/embed\/([0-9a-zA-Z_-]+)/i);
    }
    else if (urlStr.match(/youtube.com\/watch\?v=([^\s]+)/i)) {
      [, youtubeid] = urlStr.match(/youtube.com\/watch\?v=([^\s]+)/i);
    }
    else if (urlStr.match(/youtu.be\/([0-9a-zA-Z_-]+)/i)) {
      [, youtubeid] = urlStr.match(/youtu.be\/([0-9a-zA-Z_-]+)/i);
    }

    if (youtubeid && youtubeid.length > 0) {
      this.setState({
        urlValidateStatus: 'success',
        urlHelp: '',
      });
    }
    else {
      this.setState({
        urlValidateStatus: 'warning',
        urlHelp: 'Not a valid Youtube URL',
      });
    }

    this.props.updateNode(this.props.address, { youtubeid });
  }

  onAspectChange = (e) => {
    const aspect = e.target.value;
    this.props.updateNode(this.props.address, { aspect });
  }

  popoverContent = () => (
    <React.Fragment>
      <div className="label">
        <div className="main">Youtube URL</div>
        <div className="help">or Youtube's shortened URL or embeddable URL</div>
      </div>
      <FormItem
        hasFeedback={false}
        validateStatus={this.state.urlValidateStatus}
        help={this.state.urlHelp}
      >
        <Input
          placeholder="www.youtube.com/..."
          onPressEnter={this.onURLEnter}
          onBlur={this.onURLEnter}
        />
      </FormItem>

      <div className="divider" />

      <div className="label">
        <div className="main">Aspect ratio</div>
        <div className="help">Avoid letterboxed paddings on sides or top & bottom.</div>
      </div>

      <RadioGroup defaultValue={this.props.aspect} size="small" buttonStyle="solid" onChange={this.onAspectChange}>
        <RadioButton value="4by3">4:3</RadioButton>
        <RadioButton value="16by9">16:9</RadioButton>
      </RadioGroup>

    </React.Fragment>
  );

  onMouseOver = (e) => {
    this.setState({ showBtn: true });
    e.stopPropagation();
  };

  onMouseOut = (e) => {
    this.setState({ showBtn: false });
    e.stopPropagation();
  };

  render() {
    const { youtubeid, aspect, publish }  = this.props;

    return (
      <div
        className={cx(
          'pvideo',
          this.props.className,
        )}
        onMouseOver={this.onMouseOver}
        onFocus={this.onMouseOver}
        onMouseOut={this.onMouseOut}
        onBlur={this.onMouseOut}
      >
        <div
          className={cx(
            'embed-responsive',
            {
              'embed-responsive-16by9': aspect === '16by9',
              'embed-responsive-4by3': (aspect === '4by3'),
            },
          )}
        >
          <iframe
            className="embed-responsive-item"
            title="video"
            src={`https://www.youtube.com/embed/${youtubeid}`}
            frameBorder="0"
            style={{ border: 0 }} allowFullScreen
          />
        </div>

        <EditorElementPopover
          usecase="video"
          showBtn={this.state.showBtn}
          btnLabel="video"
          title="Video settings"
          content={this.popoverContent()}
          placement="bottomLeft"
          publish={publish}
        />

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/components/editor/elements/PVideo.jsx